import { createSlice } from '@reduxjs/toolkit';

const customerSupportSlice = createSlice({
  name: 'faq',
  initialState: {
    getfaqData: {},
    getfaqDataIsLoading: false,
    getfaqDataErrorMsg: null,
  },
  reducers: {
    getFAQDataReq: (state, action) => { },
    getFAQDataSuccess: (state, action) => ({
      ...state,
      getfaqData: action.payload,
      getfaqDataIsLoading: false,
      getfaqDataErrorMsg: null,
    }),
    getFAQDataFailure: (state, action) => ({
      ...state,
      getfaqDataIsLoading: false,
      getfaqDataErrorMsg: action.payload,
    }),
    getFAQDataLoading: (state) => ({
      ...state,
      getfaqDataIsLoading: true,
      getfaqDataErrorMsg: null,
    }),
    getFAQDataClear: (state) => ({
      ...state,
      getfaqData: {},
      getfaqDataIsLoading: false,
      getfaqDataErrorMsg: null,
    }),
  },
});

export const {
  getFAQDataReq,
  getFAQDataSuccess,
  getFAQDataFailure,
  getFAQDataLoading,
  getFAQDataClear,
} = customerSupportSlice.actions;

export default customerSupportSlice.reducer;
